import { useMemo } from "react";
import { useReportOverview } from "@/profitability/overview/query";
import { useReportOutput } from "@/profitability/query";
import { EMPTY_REVIEW } from "@/profitability/review/review-spec";
import { objectsOf } from "./objects";

/**
 * The records of a template's period, the latest unless `periodId` names
 * one (its jobs, technicians, units), how the script asks for them to be
 * reviewed (the API's `overview.review`, the only spec there is), and the
 * period's whole output and run, for its panes.
 */
export const useTemplateRecords = (
  businessId: string,
  reportId: string,
  periodId?: string | null,
) => {
  const overview = useReportOverview(businessId, reportId, periodId);
  const interactive = !!overview.data?.run?.interactive_available;
  const runId = interactive && overview.data?.run ? overview.data.run.id : "";
  const output = useReportOutput(businessId, runId);
  const records = useMemo(
    () => ({
      objects: objectsOf(output.data),
      spec: overview.data?.review ?? EMPTY_REVIEW,
      output: output.data,
      run: overview.data?.run ?? null,
      currency: output.data?.currency ?? overview.data?.currency ?? null,
    }),
    [output.data, overview.data],
  );
  return {
    ...records,
    /** The period's rows are still out. An empty object list is not "no review". */
    recordsPending: interactive && output.isPending,
  };
};
